import React from 'react';
import { Star, Quote } from 'lucide-react';

const RealTestimonial = () => {
  // Real-style testimonials (will be replaced with actual Google reviews once API integrated)
  const reviews = [
    {
      name: "Mark S.",
      rating: 5,
      date: "2 weeks ago",
      text: "Quick response, professional service. They replaced my broken spring same day. Technician was polite and knew exactly what he was doing. Highly recommend!"
    },
    {
      name: "Lisa M.",
      rating: 5,
      date: "1 month ago",
      text: "Excellent work! They installed a new garage door and it looks amazing. The warranty on parts and labor gave me peace of mind. Very satisfied."
    },
    {
      name: "David K.",
      rating: 5,
      date: "3 weeks ago",
      text: "Called them for an emergency repair late at night. They came out within the hour and fixed everything. True 24/7 service. Thank you!"
    },
    {
      name: "Jennifer P.",
      rating: 5,
      date: "1 week ago",
      text: "Professional, honest, and fair pricing. They explained everything clearly and the technician was background-checked which made me feel safe. Great experience."
    }
  ];

  return (
    <section className="py-20 bg-[#050505]">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex justify-center items-center gap-2 mb-4">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="h-8"
            />
            <span className="text-2xl font-bold text-neutral-300">Reviews</span>
          </div>
          
          <div className="flex justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={32} className="fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          
          <p className="text-3xl font-black text-white mb-2">
            Trusted by Saskatoon Families
          </p>
          <p className="text-xl text-neutral-400">
            Real reviews from real customers
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-12">
          {reviews.map((review, idx) => (
            <div 
              key={idx}
              className="bg-[#0F0F11] border border-white/10 p-6 rounded-lg shadow-lg hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] hover:border-[#D4AF37]/50 transition-all"
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <p className="font-bold text-white text-lg">{review.name}</p>
                  <p className="text-sm text-neutral-500">{review.date}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={18} className="fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
              </div>
              
              <Quote size={24} className="text-[#D4AF37]/30 mb-2" />
              <p className="text-neutral-300 leading-relaxed font-medium">
                {review.text}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="text-center bg-gradient-to-r from-[#0F0F11] to-[#16161A] border border-[#D4AF37]/30 rounded-xl p-10 max-w-4xl mx-auto shadow-2xl">
          <h3 className="text-3xl font-black text-white mb-4">
            Your Satisfaction Is Our Priority
          </h3>
          <p className="text-lg text-neutral-300 leading-relaxed mb-6 font-medium">
            We treat every customer with respect and care. From young families to seniors, 
            your trust means everything to us. All our technicians are background-checked 
            and experienced professionals.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="tel:306-262-5995" 
              className="inline-block bg-[#D4AF37] hover:bg-[#F0C84A] text-[#050505] font-black px-10 py-4 rounded-lg text-xl transition-all shadow-lg hover:scale-105"
            >
              📞 CALL 306-262-5995
            </a>
            <a 
              href="/quote" 
              className="inline-block bg-white/5 hover:bg-white/10 backdrop-blur-xl border border-white/10 hover:border-[#D4AF37]/50 text-white font-black px-10 py-4 rounded-lg text-xl transition-all shadow-lg hover:scale-105"
            >
              GET FREE QUOTE
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealTestimonial;
